import React from 'react';
import { Card } from 'components/shadcn/ui/card';
import { Button } from 'components/shadcn/ui/button';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const HGSuccessCard = ({ children, buttons }) => {
    return (
        <Card className="flex flex-col items-center p-10">
            <CheckCircleIcon className="mb-3 h-24 w-24 text-secondary" />
            <h3 className="text-center">Success!</h3>
            <p className="mb-3 text-center">{children}</p>
            {buttons && (
                <div className="flex w-full justify-center">
                    {buttons.map(({ onClick, buttonText }, index) => (
                        <Button
                            key={index}
                            onClick={onClick}
                            className={index > 0 ? 'ml-3' : ''}
                        >
                            {buttonText}
                        </Button>
                    ))}
                </div>
            )}
        </Card>
    );
};

export default HGSuccessCard;
